import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle, setProfileData } from '../../../store/commonSlice'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'
import { end_points } from '../../../services/core.index'
import { ApiServiceContext } from '../../../utils/shared.module'

import {
  avatar1,
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  avatar30,
} from '../../../utils/images/imagepath'

// function CheckList() {
//   const dispatch = useDispatch()

//   useEffect(() => {
//     dispatch(setAppTitle('Drivers List'))
//   }, [])

//   return (
//     <>

// 					<div className="page-header">
// 						<div className="row align-items-center">
// 							<div className="col-sm-6">
// 								<h3 className="page-title">Garbage Truck <span>( AB06 CD 1234 )</span></h3>
// 							</div>
// 							<div className="col-sm-6">
// 								<ul className="breadcrumb">
// 									<li className="breadcrumb-item active"><a href="index.html">Home</a></li>
// 									<li className="breadcrumb-item active"><a href="truck-list.html">Truck List</a></li>
// 									<li className="breadcrumb-item">Check List</li>
// 								</ul>
// 							</div>
// 						</div>
// 					</div>

// 					<div className="row">
// 						<div className="col-md-12">
// 							<div className="card truck-info-card success-border">
// 								<div className="card-body">
// 									<div className="row truck-widget">
// 										<div className="col-md-4">
// 											<div className="truck-img">
// 												<img src={truck3} className="img-fluid" alt="Truck"/>
// 											</div>
// 										</div>
// 										<div className="col-md-8">
// 											<div className="truck-list-info">
// 												<div className="truck-details">
// 													<div className="row align-items-center">
// 														<div className="col-md-4">
// 															<div className="truck-list-text">
// 																<p>Truck Number</p>
// 																<h6>452BG2654</h6>
// 															</div>
// 														</div>
// 														<div className="col-md-4">
// 															<div className="truck-list-text">
// 																<p>Driver Name</p>
// 																<h6>Cameron Jacob</h6>
// 															</div>
// 														</div>
// 														<div className="col-md-4">
// 															<div className="truck-list-text">
// 																<p>Inspector</p>
// 																<h6>Christopher Edward</h6>
// 															</div>
// 														</div>
// 														<div className="col-md-4">
// 															<div className="truck-list-text">
// 																<p>Company</p>
// 																<h6>ABC Company Ltd</h6>
// 															</div>
// 														</div>
// 														<div className="col-md-4">
// 															<div className="truck-list-text">
// 																<p>Status</p>
// 																<h6>Pending</h6>
// 															</div>
// 														</div>
// 														<div className="col-md-4">
// 															<div className="truck-list-text">
// 																<p>Checklist</p>
// 																<ul className="nav datas-list">
// 																	<li>
// 																		<span className="check-list-active"></span>
// 																	</li>
// 																	<li>
// 																		<span className="check-list-active"></span>
// 																	</li>
// 																	<li>
// 																		<span className="check-list-active"></span>
// 																	</li>
// 																	<li>
// 																		<span className="check-list-in-active"></span>
// 																	</li>
// 																	<li>
// 																		<span className="check-list-in-active"></span>
// 																	</li>
// 																	<li>
// 																		<span className="check-list-in-active"></span>
// 																	</li>
// 																</ul>
// 																<h5>02/<span>30</span></h5>
// 															</div>
// 														</div>
// 													</div>
// 												</div>
// 												<div className="truck-list-box">
// 													<div className="row">
// 														<div className="col-md-10">
// 															<div className="truck-list-complete">
// 																<ul className="nav">
// 																	<li className="bg-light-success">
// 																		<p>Completed Checklist</p>
// 																		<h6 className="text-success">02</h6>
// 																	</li>
// 																	<li className="bg-light-gray">
// 																		<p>Pending Checklist</p>
// 																		<h6 className="text-gray">26</h6>
// 																	</li>
// 																	<li className="bg-light-danger">
// 																		<p>Blacklist Checklist</p>
// 																		<h6 className="text-danger">04</h6>
// 																	</li>
// 																</ul>
// 															</div>
// 														</div>
// 														<div className="col-md-2">
// 															<div className="truck-list-dropdown">
// 																<a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
// 																	<i className="fas fa-ellipsis-vertical"></i>
// 																</a>
// 																<div className="dropdown-menu dropdown-menu-end">
// 																	<a href="javascript:void(0);" className="dropdown-item">
// 																		<i className="feather-eye"></i> View
// 																	</a>
// 																	<a href="javascript:void(0);" className="dropdown-item">
// 																		<i className="feather-edit"></i> Edit
// 																	</a>
// 																	<a href="javascript:void(0);" className="dropdown-item">
// 																		<i className="feather-trash-2"></i> Delete
// 																	</a>
// 																</div>
// 															</div>
// 														</div>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 					 <div className="row">
// 						<div className="col-md-5">
// 							<div className="list-checklist">
// 								<div className="list-checklist-title">
// 									<h5>Checklist</h5>
// 									<p>See below to check checklist</p>
// 								</div>

// 								<div className="list-checklist-content">
// 									<div className="checklist-tab nav nav-pills mb-3" id="pills-tab" role="tablist">
// 										<div className="checklist-nav nav-item checklist-completed" role="presentation">
// 											<div className="checklist-nav-pill nav-link active" id="pills-overall-tab" data-bs-toggle="pill" data-bs-target="#overall-home" type="button" role="tab" aria-controls="overall-home" aria-selected="true">
// 												<div className="check-list-img">
// 													<img src={truck3} alt="checklist"/>
// 												</div>
// 												<div className="checklist-tab-content">
// 													<div className="cc-checklist-tab">
// 														<h6>Check Overall Appearance</h6>
// 														<div className="content-check">
// 															<p>Lorem Ipsum is simply dummy text</p>
// 														</div>
// 													</div>
// 													<i className="fa-regular fa-circle-check"></i>
// 												</div>
// 											</div>
// 										</div>
// 										<div className="checklist-nav nav-item checklist-minor">
// 											<div className="checklist-nav-pill" id="pills-review-tab" data-bs-toggle="pill" data-bs-target="#review-tab" role="tab" aria-controls="review-tab" aria-selected="false">
// 												<div className="check-list-img">
// 													<img src={review} alt="checklist"/>
// 												</div>
// 												<div className="checklist-tab-content">
// 													<div className="cc-checklist-tab">
// 														<h6>Review Previous VIR</h6>
// 														<div className="content-check">
// 															<p>It is a long established fact that a reader It is a long established fact that a reader </p>
// 														</div>
// 													</div>
// 													<i className="fa-regular fa-circle-check"></i>
// 												</div>
// 											</div>
// 										</div>
// 										<div className="checklist-nav nav-item">
// 											<div className="checklist-nav-pill" id="pills-inspection-tab" data-bs-toggle="pill" data-bs-target="#inspection-tab" role="tab" aria-controls="inspection-tab" aria-selected="false">
// 												<div className="check-list-img">
// 													<img src={inspection} alt="checklist"/>
// 												</div>

// 												<div className="checklist-tab-content">
// 													<div className="cc-checklist-tab">
// 														<h6>Walk-around Inspection</h6>
// 														<div className="content-check">
// 															<p>There are many variations of passages </p>
// 														</div>
// 													</div>
// 													<i className="fa-regular fa-circle-check"></i>
// 												</div>
// 											</div>
// 										</div>
// 										<div className="checklist-nav nav-item">
// 											<div className="checklist-nav-pill" id="pills-light-tab" data-bs-toggle="pill" data-bs-target="#light-tab" role="tab" aria-controls="light-tab" aria-selected="false">
// 												<div className="check-list-img">
// 													<img src={light} alt="checklist"/>
// 												</div>

// 												<div className="checklist-tab-content">
// 													<div className="cc-checklist-tab">
// 														<h6>Check Lights</h6>
// 														<div className="content-check">
// 															<p>The standard chunk of Lorem Ipsum used. </p>
// 														</div>
// 													</div>
// 													<i className="fa-regular fa-circle-check"></i>
// 												</div>
// 											</div>
// 										</div>
// 										<div className="checklist-nav nav-item checklist-major">
// 											<div className="checklist-nav-pill" id="pills-engine-tab" data-bs-toggle="pill" data-bs-target="#engine-tab" role="tab" aria-controls="engine-tab" aria-selected="false">
// 												<div className="check-list-img">
// 													<img src={engine} alt="checklist"/>
// 												</div>

// 												<div className="checklist-tab-content">
// 													<div className="cc-checklist-tab">
// 														<h6>Check Engine</h6>
// 														<div className="content-check">
// 															<p>Lorem Ipsum is simply dummy text of the printing </p>
// 														</div>
// 													</div>
// 													<i className="feather-alert-triangle"></i>
// 												</div>
// 											</div>
// 										</div>
// 										<div className="checklist-nav nav-item">
// 											<div className="checklist-nav-pill" id="pills-interior-tab" data-bs-toggle="pill" data-bs-target="#interior-tab" role="tab" aria-controls="review-tab" aria-selected="false">
// 												<div className="check-list-img">
// 													<img src={interior} alt="checklist"/>
// 												</div>

// 												<div className="checklist-tab-content">
// 													<div className="cc-checklist-tab">
// 														<h6>Inspect Interior</h6>
// 														<div className="content-check">
// 															<p>Lorem Ipsum is simply dummy text of the printing </p>
// 														</div>
// 													</div>
// 													<i className="fa-regular fa-circle-check"></i>
// 												</div>
// 											</div>
// 										</div>

// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 						<div className="col-md-7 mt-4 mt-md-0">
// 							<div className="tab-content" id="pills-tabContent">
// 								<div className="tab-pane fade show active" id="overall-home" role="tabpanel" aria-labelledby="pills-home-tab">
// 									<div className="checklist-tabinfo-content">
// 										<h4>Overall Appearance</h4>
// 										<div className="step-checklist">
// 											<div className="step-checklist-title">
// 												<div className="cmp-checklist-title">
// 													<h5>Engine Compartment + 1 Axle</h5>
// 													<p>4 Checklist</p>
// 												</div>
// 												<span>4 Completed</span>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Leaks, Leans, Lights</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leaks</p>
// 														<small>Ensure there are no LEAKS underneath the engine compartment</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leans</p>
// 														<small>Make sure the truck isn’t LEANing to one side which could indicate a suspension problem or low tire pressure</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>LIGHTs</p>
// 														<small>Lastly, verify that the LIGHTs on the front of the truck are the proper color, securely mounted, not cracked or dirty, and have no moisture inside.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>3 Fluids</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Coolant</p>
// 														<small>Verify proper level, not leaking, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Oil</p>
// 														<small>indicate where the dipstick is located and that the oil is at the proper level.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Power Steering fluid</p>
// 														<small>not leaking, proper level, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>3 Components</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Alternator</p>
// 														<small>Wires are securely mounted and not frayed. Belt or gear driven, belt has no more than 1/2" to 3/4" of play, no splits or cuts.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Water Pump</p>
// 														<small>Securely mounted, not BBC; not leaking, belt or gear driven, belt has no more than 1/2" to 3/4" inch of play and has no splits or cuts.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Air Compressor</p>
// 														<small>not BBC and must be securely mounted; no audible leaks and belt or gear driven. If belt-driven, belt has no more than 1/2" to 3/4" inch of play and has no splits or cuts.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Belts and Hoses</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Belt and Hoses</p>
// 														<small>After properly inspecting the power steering hose and the coolant hose, tell the tester that you would inspect all remaining hoses the same way.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>

// 								<div className="tab-pane fade" id="review-tab" role="tabpanel" aria-labelledby="pills-review-tab">
// 									<div className="checklist-tabinfo-content">
// 										<h4>Review</h4>
// 										<div className="step-checklist">
// 											<div className="step-checklist-title">
// 												<div className="cmp-checklist-title">
// 													<h5>Engine Compartment + 1 Axle</h5>
// 													<p>4 Checklist</p>
// 												</div>
// 												<span>4 Completed</span>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Leaks, Leans, Lights</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leaks</p>
// 														<small>Ensure there are no LEAKS underneath the engine compartment</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li className="minor-issues">
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>

// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leans</p>
// 														<small>Make sure the truck isn’t LEANing to one side which could indicate a suspension problem or low tire pressure</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>LIGHTs</p>
// 														<small>Lastly, verify that the LIGHTs on the front of the truck are the proper color, securely mounted, not cracked or dirty, and have no moisture inside.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>3 Fluids</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Coolant</p>
// 														<small>Verify proper level, not leaking, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li className="minor-issues">
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Oil</p>
// 														<small>indicate where the dipstick is located and that the oil is at the proper level.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Power Steering fluid</p>
// 														<small>not leaking, proper level, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 								<div className="tab-pane fade" id="inspection-tab" role="tabpanel" aria-labelledby="pills-inspection-tab">
// 									<div className="checklist-tabinfo-content">
// 										<h4>Walk-around Inspection</h4>
// 										<div className="step-checklist">
// 											<div className="step-checklist-title">
// 												<div className="cmp-checklist-title">
// 													<h5>Engine Compartment + 1 Axle</h5>
// 													<p>4 Checklist</p>
// 												</div>
// 												<span>4 Completed</span>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Leaks, Leans, Lights</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leaks</p>
// 														<small>Ensure there are no LEAKS underneath the engine compartment</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leans</p>
// 														<small>Make sure the truck isn’t LEANing to one side which could indicate a suspension problem or low tire pressure</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>LIGHTs</p>
// 														<small>Lastly, verify that the LIGHTs on the front of the truck are the proper color, securely mounted, not cracked or dirty, and have no moisture inside.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>3 Fluids</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Coolant</p>
// 														<small>Verify proper level, not leaking, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Oil</p>
// 														<small>indicate where the dipstick is located and that the oil is at the proper level.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Power Steering fluid</p>
// 														<small>not leaking, proper level, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 								<div className="tab-pane fade" id="light-tab" role="tabpanel" aria-labelledby="pills-light-tab">
// 									<div className="checklist-tabinfo-content">
// 										<h4>Check Lights</h4>
// 										<div className="step-checklist">
// 											<div className="step-checklist-title">
// 												<div className="cmp-checklist-title">
// 													<h5>Engine Compartment + 1 Axle</h5>
// 													<p>4 Checklist</p>
// 												</div>
// 												<span>4 Completed</span>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Leaks, Leans, Lights</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leaks</p>
// 														<small>Ensure there are no LEAKS underneath the engine compartment</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leans</p>
// 														<small>Make sure the truck isn’t LEANing to one side which could indicate a suspension problem or low tire pressure</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>LIGHTs</p>
// 														<small>Lastly, verify that the LIGHTs on the front of the truck are the proper color, securely mounted, not cracked or dirty, and have no moisture inside.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>3 Fluids</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Coolant</p>
// 														<small>Verify proper level, not leaking, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Oil</p>
// 														<small>indicate where the dipstick is located and that the oil is at the proper level.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Power Steering fluid</p>
// 														<small>not leaking, proper level, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 								<div className="tab-pane fade" id="engine-tab" role="tabpanel" aria-labelledby="pills-engine-tab">
// 									<div className="checklist-tabinfo-content">
// 										<h4>Check Engine</h4>
// 										<div className="step-checklist">
// 											<div className="step-checklist-title">
// 												<div className="cmp-checklist-title">
// 													<h5>Engine Compartment cont’d</h5>
// 													<p>4 Checklist</p>
// 												</div>
// 												<span>3 Completed</span>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Steering</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Power Steering Box <span className="checklist-error-info"><i className="fa-solid fa-circle-info"></i></span></p>
// 														<small>not BBC, no leaks, securely mounted, all hardware present, none missing; hose no ABC’s, securely mounted.</small>
// 														<ul>
// 															<li >
// 																No Issues
// 															</li>
// 															<li className="major-issues">
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Pitman Arm</p>
// 														<small>not BBC, securely mounted, all hardware in place none missing. Castle nuts not BBC, cotter pins in place.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Drag Link <span className="checklist-error-info"><i className="fa-solid fa-circle-info"></i></span></p>
// 														<small>not BBC, securely mounted, castle nuts not BBC, cotter pin in place. Bushings: no ABC’s, properly greased.</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li className="major-issues">
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>4</span></div>
// 													<div className="cc-steps-check">
// 														<p>Upper and Lower Control Arms and Tie Rod</p>
// 														<small>BBC, securely mounted, all hardware present.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Suspension</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Spring mounts <span className="checklist-error-info"><i className="fa-solid fa-circle-info"></i></span></p>
// 														<small>Spring mounts and hardware are not BBC, securely mounted to frame.</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li className="major-issues">
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leaf Springs</p>
// 														<small>not BBC, securely mounted, no scissoring</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>U-bolts</p>
// 														<small>not BBC, securely mounted, no shiny metal, nuts in place not BBC.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>4</span></div>
// 													<div className="cc-steps-check">
// 														<p>Shock absorber <span className="checklist-error-info"><i className="fa-solid fa-circle-info"></i></span></p>
// 														<small>not BBC, securely mounted, no leaks, rubber bushings no ABC’s.</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li className="major-issues">
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Suspension</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Brake Hose <span className="checklist-error-info"><i className="fa-solid fa-circle-info"></i></span></p>
// 														<small>hose to brakes chamber not split or cut, no audible leaks, securely mounted.</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li className="major-issues">
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Brake Chamber</p>
// 														<small>not BBC, securely mounted, no audible leaks, all hardware in place none missing.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Slack Adjuster</p>
// 														<small>not BBC securely mounted, no missing pins, pushrod has no more than 1" of play and is at a 90° angle to brake chamber.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>4</span></div>
// 													<div className="cc-steps-check">
// 														<p>Brake Drum</p>
// 														<small>not BBC, securely mounted, no blueing from heat.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>5</span></div>
// 													<div className="cc-steps-check">
// 														<p>Brake Pads<span className="checklist-error-info"><i className="fa-solid fa-circle-info"></i></span></p>
// 														<small>not BBC, securely mounted, no less than 1/4" of pad.</small>
// 														<ul>
// 															<li>
// 																No Issues
// 															</li>
// 															<li className="major-issues">
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 								<div className="tab-pane fade" id="interior-tab" role="tabpanel" aria-labelledby="pills-interior-tab">
// 									<div className="checklist-tabinfo-content">
// 										<h4>Inspect Interior</h4>
// 										<div className="step-checklist">
// 											<div className="step-checklist-title">
// 												<div className="cmp-checklist-title">
// 													<h5>Engine Compartment + 1 Axle</h5>
// 													<p>4 Checklist</p>
// 												</div>
// 												<span>4 Completed</span>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>Leaks, Leans, Lights</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leaks</p>
// 														<small>Ensure there are no LEAKS underneath the engine compartment</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Leans</p>
// 														<small>Make sure the truck isn’t LEANing to one side which could indicate a suspension problem or low tire pressure</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>LIGHTs</p>
// 														<small>Lastly, verify that the LIGHTs on the front of the truck are the proper color, securely mounted, not cracked or dirty, and have no moisture inside.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 											<div className="step-checklisting">
// 												<h6>3 Fluids</h6>
// 												<div className="step-checklisting-details">
// 													<div><span>1</span></div>
// 													<div className="cc-steps-check">
// 														<p>Coolant</p>
// 														<small>Verify proper level, not leaking, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>2</span></div>
// 													<div className="cc-steps-check">
// 														<p>Oil</p>
// 														<small>indicate where the dipstick is located and that the oil is at the proper level.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 												<div className="step-checklisting-details">
// 													<div><span>3</span></div>
// 													<div className="cc-steps-check">
// 														<p>Power Steering fluid</p>
// 														<small>not leaking, proper level, securely mounted, not BBC; check the hoses for splits or cuts and ensure they are securely mounted.</small>
// 														<ul>
// 															<li className="no-issues">
// 																No Issues
// 															</li>
// 															<li>
// 																Major
// 															</li>
// 															<li>
// 																Minor
// 															</li>
// 														</ul>
// 													</div>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					 </div>

//     </>
//   )
// }
function CheckList() {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState<boolean>(false)
  const { getData } = useContext(ApiServiceContext)
  const [listData, setListData] = useState<any>([
    {
      chk_Master_Id: 1,
      checklist_Master_Value: 'Engine Compartment',
      status: 0,
      sub_category: 'Leaks, Leans, Lights',
      master_ImagePath: '/Checklist_Images/Truck_checklist1.png',
    },
    {
      chk_Master_Id: 2,
      checklist_Master_Value: 'Side and Back of Truck +1 Axle\r\n',
      status: 0,
      sub_category: '3 Fluids',
      master_ImagePath: '/Checklist_Images/Truck_checklist1.png',
    },
  ])
  const [totalPage, setTotal] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [limitCount] = useState<number>(100)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const getDriversList = async (search?: any) => {
    let nameSearch = search
    if (nameSearch == undefined) {
      nameSearch = ''
    }
    const urls = end_points.getUsers.url
    // urls += `?page=${page}&limit=${limitCount}&searchTerm=${nameSearch}`

    const response = await getData(urls)
    if (response?.status == 200) {
      console.log(response?.data)
      // setListData(response?.data?.data)
      // setTotal(response?.data?.total_records)

      setLoading(false)
    }
  }

  useEffect(() => {
    getDriversList()
  }, [])

  useEffect(() => {
    dispatch(setAppTitle('Manage Check List'))
  }, [])

  const data = listData.map((item: any) => {
    return {
      id: item?.id,
      driver_name: item?.checklist_Master_Value,
      sub_category: item?.sub_category,
      status: 'Active',
    }
  })

  const driverName = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='driver-preview.html' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar1}
              alt='Profiles'
            />
          </a>
          <a href='driver-preview.html'>
            {data?.driver_name} <span>{data?.company_name}</span>
          </a>
        </h2>
      </>
    )
  }
  const licene = (data: any, index: any) => {
    return <>{data.license_number}</>
  }

  const contact = (data: any, index: any) => {
    return (
      <>
        <span className='light-text'>{data.sub_category}</span>
      </>
    )
  }

  const status = (data: any, index: any) => {
    return (
      <>
        <span className='badge bg-light-success'>{data.status}</span>
      </>
    )
  }

  const action = (data: any, index: any) => {
    return (
      <>
        <div className='dropdown'>
          <a
            href='javascript:void(0);'
            className='dropdown-toggle'
            data-bs-toggle='dropdown'
          >
            <i className='feather-more-vertical'></i>
          </a>
          <div className='dropdown-menu dropdown-menu-end'>
            <Link
              to={routes.driverProfile.path}
              onClick={() => {
                dispatch(setProfileData(data))
              }}
              className='dropdown-item'
            >
              <i className='feather-eye'></i> View
            </Link>

            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-edit'></i> Edit
            </a>
            <a href='javascript:void(0);' className='dropdown-item'>
              <i className='feather-trash-2'></i> Delete
            </a>
          </div>
        </div>
      </>
    )
  }

  const vehicleInfo = (data: any, index: any) => {
    return (
      <>
        <h2 className='table-avatar'>
          <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
            <img
              className='avatar-img rounded-circle'
              src={avatar2}
              alt='Profiles'
            />
          </a>
          <a href='javascript:void(0);'>
            {data.model_name} <span>{data.vin_number}</span>
          </a>
        </h2>
      </>
    )
  }

  return (
    <>
      <div className='checkList-wrapper'>
        <div className='page-header'>
          <div className='row align-items-center'>
            <div className='col-sm-6'>
              <h3 className='page-title'>Manage Check List</h3>
            </div>
            <div className='col-sm-6'>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item active'>
                  <a href='index.html'>Home</a>
                </li>
                <li className='breadcrumb-item'>Drivers List</li>
              </ul>
            </div>
          </div>
        </div>

        <div className='row align-items-center cc-create-checklist'>
          <div className='col-md-6'>
            <div className='truck-list'>
              <ul className='nav mb-0'>
                <li className='active'>
                  <a href='javascript:void(0);'>All</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>Active</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>In Active</a>
                </li>
              </ul>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='truck-search'>
              <div className='addNew-checkList'>
                <Link
                  to={routes.createCheckList.path}
                  className='btn btn-primary'
                >
                  Add Check List
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card table-card'>
              <div className='card-body'>
                <div className='row align-items-center'>
                  <div className='col-md-6'>
                    <div id='tablelength'></div>
                  </div>
                  <div className='col-md-6'>
                    <ul className='nav nav-table-filter'>
                      <li>Search:</li>
                      <li>
                        <div id='tablefilter'></div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='table-responsive'>
                  {/* <table className="table datatable mb-0">
											  <thead>
												  <tr>
													  <th className="no-sort">
														  <div className="table-checkbox">
															  <label className="check-input">
																  <input type="checkbox" id="select-all"/>
																  <span className="box"></span>
															  </label>
														 </div>
													  </th>
													  <th>ID</th>
													  <th>Driver Name</th>
													  <th>Licence Number</th>
													  <th>Contact</th>
													  <th>Vehicle Info</th>
													  <th>Status</th>
													  <th className="no-sort"></th>
												  </tr>
											  </thead>
											  <tbody>
												  <tr>
													  <td>
														  <div className="table-checkbox">
															  <label className="check-input">
																  <input type="checkbox"/>
																  <span className="box"></span>
															  </label>
														 </div>
													  </td>
													  <td>MFD 001</td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="driver-preview.html" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar1} alt="Profiles"/></a>
															  <a href="driver-preview.html">
																  Cameron Jacob <span>ABC Company</span>
															  </a>
														  </h2>
													  </td>
													  <td>G544061739250</td>
													  <td><span className="light-text">+1 408 XXX XXXX</span></td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="javascript:void(0);" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar2} alt="Profiles"/></a>
															  <a href="javascript:void(0);">
																  Garbage Truck <span>AB06 CD 1234</span>
															  </a>
														  </h2>
													  </td>
													  <td>
														  <span className="badge bg-light-success">Active</span>
													  </td>
													  <td className="table-action">
														  <div className="dropdown">
															  <a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
																  <i className="feather-more-vertical"></i>
															  </a>
															  <div className="dropdown-menu dropdown-menu-end">
															  <Link to={routes.driverProfile.path} className="dropdown-item">
																	  <i className="feather-eye"></i> View								
															  </Link>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-edit"></i> Edit
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-trash-2"></i> Delete
																  </a>
															  </div>
														  </div>
													  </td>
												  </tr>
												  <tr>
													  <td>
														  <div className="table-checkbox">
															  <label className="check-input">
																  <input type="checkbox"/>
																  <span className="box"></span>
															  </label>
														 </div>
													  </td>
													  <td>MFD 002</td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="driver-preview.html" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar11} alt="Profiles"/></a>
															  <a href="driver-preview.html">
																  Amy Jackson <span>ABC Company</span>
															  </a>
														  </h2>
													  </td>
													  <td>ADC4061739690</td>
													  <td><span className="light-text">+1 580 XXX XXXX</span></td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="javascript:void(0);" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar17} alt="Profiles"/></a>
															  <a href="javascript:void(0);">
																  Truck <span>AB06 CD 1234</span>
															  </a>
														  </h2>
													  </td>
													  <td>
														  <span className="badge bg-light-success">Active</span>
													  </td>
													  <td className="table-action">
														  <div className="dropdown">
															  <a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
																  <i className="feather-more-vertical"></i>
															  </a>
															  <div className="dropdown-menu dropdown-menu-end">
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-eye"></i> View
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-edit"></i> Edit
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-trash-2"></i> Delete
																  </a>
															  </div>
														  </div>
													  </td>
												  </tr>
												  <tr>
													  <td>
														  <div className="table-checkbox">
															  <label className="check-input">
																  <input type="checkbox"/>
																  <span className="box"></span>
															  </label>
														 </div>
													  </td>
													  <td>MFD 003</td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="driver-preview.html" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar29} alt="Profiles"/></a>
															  <a href="driver-preview.html">
																  Christopher Evan <span>ABC Company</span>
															  </a>
														  </h2>
													  </td>
													  <td>F25592150094</td>
													  <td><span className="light-text">+1 124 XXX XXXX</span></td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="javascript:void(0);" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar13} alt="Profiles"/></a>
															  <a href="javascript:void(0);">
																  Semi-Truck <span>AB06 CD 1234</span>
															  </a>
														  </h2>
													  </td>
													  <td>
														  <span className="badge bg-light-danger">In Active</span>
													  </td>
													  <td className="table-action">
														  <div className="dropdown">
															  <a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
																  <i className="feather-more-vertical"></i>
															  </a>
															  <div className="dropdown-menu dropdown-menu-end">
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-eye"></i> View
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-edit"></i> Edit
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-trash-2"></i> Delete
																  </a>
															  </div>
														  </div>
													  </td>
												  </tr>
												  <tr>
													  <td>
														  <div className="table-checkbox">
															  <label className="check-input">
																  <input type="checkbox"/>
																  <span className="box"></span>
															  </label>
														 </div>
													  </td>
													  <td>MFD 004</td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="driver-preview.html" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar30} alt="Profiles"/></a>
															  <a href="driver-preview.html">
																  Kevin <span>ABC Company</span>
															  </a>
														  </h2>
													  </td>
													  <td>DA5592151111</td>
													  <td><span className="light-text">+1 256 XXX XXXX</span></td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="javascript:void(0);" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar1} alt="Profiles"/></a>
															  <a href="javascript:void(0);">
																  Tow Truck <span>AB06 CD 1234</span>
															  </a>
														  </h2>
													  </td>
													  <td>
														  <span className="badge bg-light-success">Active</span>
													  </td>
													  <td className="table-action">
														  <div className="dropdown">
															  <a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
																  <i className="feather-more-vertical"></i>
															  </a>
															  <div className="dropdown-menu dropdown-menu-end">
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-eye"></i> View
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-edit"></i> Edit
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-trash-2"></i> Delete
																  </a>
															  </div>
														  </div>
													  </td>
												  </tr>
												  <tr>
													  <td>
														  <div className="table-checkbox">
															  <label className="check-input">
																  <input type="checkbox"/>
																  <span className="box"></span>
															  </label>
														 </div>
													  </td>
													  <td>MFD 005</td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="driver-preview.html" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar11} alt="Profiles"/></a>
															  <a href="driver-preview.html">
																  Sebastian Thomas <span>ABC Company</span>
															  </a>
														  </h2>
													  </td>
													  <td>KJ55921521546</td>
													  <td><span className="light-text">+1 524 XXX XXXX</span></td>
													  <td>
														  <h2 className="table-avatar">
															  <a href="javascript:void(0);" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src={avatar17} alt="Profiles"/></a>
															  <a href="javascript:void(0);">
																  Tanker Truck <span>AB06 CD 1234</span>
															  </a>
														  </h2>
													  </td>
													  <td>
														  <span className="badge bg-light-success">Active</span>
													  </td>
													  <td className="table-action">
														  <div className="dropdown">
															  <a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
																  <i className="feather-more-vertical"></i>
															  </a>
															  <div className="dropdown-menu dropdown-menu-end">
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-eye"></i> View
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-edit"></i> Edit
																  </a>
																  <a href="javascript:void(0);" className="dropdown-item">
																	  <i className="feather-trash-2"></i> Delete
																  </a>
															  </div>
														  </div>
													  </td>
												  </tr>
											  </tbody>
										  </table> */}

                  <table className='table datatable mb-0'>
                    <DataTable
                      // paginatorTemplate='CurrentPageReport  PrevPageLink PageLinks NextPageLink  '
                      // currentPageReportTemplate='{first} to {last} of {totalRecords} items'
                      className=''
                      value={data}
                      paginator
                      rows={5}
                      tableStyle={{ minWidth: '50rem' }}
                    >
                      <Column
                        field='main category'
                        header='Main Category'
                        body={driverName}
                        sortable
                      ></Column>
                      <Column
                        field='sub category'
                        header='Sub Category'
                        body={contact}
                        sortable
                      ></Column>

                      <Column
                        field='status'
                        header='Status'
                        body={status}
                        sortable
                      ></Column>
                      <Column body={action}></Column>
                    </DataTable>
                  </table>
                </div>
                <div className='tab-footer'>
                  <div className='row align-items-center'>
                    <div className='col-md-6'>
                      <div id='tableinfo'></div>
                    </div>
                    <div className='col-md-6'>
                      <div id='tablepage'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default CheckList
